import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';

export function ConfirmAlertWithMpin({
    isOpen,
    title,
    message,
    request,
    positiveButtonTitle,
    positiveButtonClick,
    negativeButtonTitle,
    negativeButtonClick
}) {
    const [open, setOpen] = useState(isOpen);
    const [mpin, setMpin] = useState('');
    const [mpinError, setMpinError] = useState(false);
    const classes = commonStyle();
    var IsPayoutDeleteBeneWithMpin =
        localStorage.getItem('IsPayoutDeleteBeneWithMpin') === 'true';

    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen]);

    const handlePositiveClick = () => {
        if (!mpin) {
            setMpinError(true);
            return;
        }
        setMpinError(false);
        setOpen(false);
        positiveButtonClick({ ...request, mpin });
    };

    const handleNegativeClick = () => {
        setOpen(false);
        negativeButtonClick();
    };

    return (
        <Dialog
            open={open}
            onClose={handleNegativeClick}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {message}
                </DialogContentText>
                {IsPayoutDeleteBeneWithMpin && (
                    <TextField
                        autoFocus
                        margin="dense"
                        id="mpin"
                        label="MPIN"
                        type="password"
                        fullWidth
                        value={mpin}
                        onChange={(e) => setMpin(e.target.value)}
                        error={mpinError}
                        helperText={mpinError ? 'MPIN is required' : ''}
                    />
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    type="reset"
                    onClick={handleNegativeClick}
                    variant="contained"
                >
                    {negativeButtonTitle ? negativeButtonTitle : 'No'}
                </Button>
                <Button
                    onClick={handlePositiveClick}
                    className={classes.CustomPrimaryButtonStyle}
                >
                    {positiveButtonTitle ? positiveButtonTitle : 'Yes'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
